<template>
  <div>
    <div
      :class="{
        'text-danger': true,
      }"
    >
      This message may contain a phone number outside the UK, which costs more
      to call.
    </div>
  </div>
</template>
